// France
export const locale = {
  lang: 'fa',
  data: {
    TRANSLATOR: {
      SELECT: 'زبان خود را انتخاب کنید',
    },
    GENERAL: {
      PROGRESS: 'پیشرفت',
      TEAM: 'تیم',
      SORT_BY: 'مرتب‌سازی بر اساس',
      FILTER_BY: 'فیلتر بر اساس',
      IMPACT_LEVEL: 'سطح تأثیر',
      QUICK_TOOLS: 'ابزارهای سریع',
      QUICK_LINKS: 'لینک‌های سریع',
      COMPLETED: 'تکمیل شده',
      IN_PROGRESS: 'در حال انجام',
      SEARCH: 'جستجو...',
      RECENTLY_SEARCHED: 'جستجوهای اخیر',
      NO_RESULT_FOUND: 'نتیجه‌ای یافت نشد',
      NO_RESULT_FOUND_DESC: 'لطفاً با یک پرسش متفاوت دوباره امتحان کنید',
      ADVANCED_SEARCH: 'جستجوی پیشرفته',
      SEARCH_PREFERENCES: 'تنظیمات جستجو',
      TODAY_BUTTON: 'امروز',
      WEEK_BUTTON: 'هفته',
      DAY_BUTTON: 'روز',
      FILTER_BUTTON: 'فیلتر',
      CREATE_BUTTON: 'ایجاد',
      VIEW_BUTTON: 'نمایش',
      CANCEL_BUTTON: 'انصراف',
      SEARCH_BUTTON: 'جستجو',
      SAVE_CHANGES_BUTTON: 'ذخیره تغییرات',
      LOADING_DATE_RANGE: 'بارگذاری دامنه تاریخ...',
    },
    MENU: {
      NEW: 'جدید',
      ACTIONS: 'عملیات',
      CREATE_POST: 'ایجاد مطلب جدید',
      PAGES: 'صفحات',
      FEATURES: 'ویژگی‌ها',
      APPS: 'برنامه‌ها',
      DASHBOARD: 'ظرفیت و قیمتس',
      LAYOUT_BUILDER: 'تنظیمات قالب',
      CRAFTED: 'ساخته شده',
      ACCOUNTS: 'حساب‌ها',
      OVERVIEW: 'مرور',
      SETTINGS: 'تنظیمات',
      ERRORS: 'خطاها',
      ERROR_404: 'خطا 404',
      ERROR_500: 'خطا 500',
      PASCAL: 'پاسکال',
      COMPANY: 'شرکت دان استودیو',
      ABOUT: 'درباره ما',
      SUPPORT: 'پشتیبانی',
      DOCUMENTS: 'مستندات',
      ACTIVITY_LOGS: 'گزارش‌های فعالیت',
      MY_PROFILE: 'پروفایل من',
      MY_PROJECTS: 'پروژه‌های من',
      MY_SUBSCRIPTION: 'اشتراک من',
      REFERRALS: 'ارجاعات',
      BILLING: 'صورتحساب',
      PAYMENTS: 'پرداخت‌ها',
      STATEMENTS: 'گزارش‌ها',
      NOTIFICATIONS: 'اعلان‌ها',
      MY_STATEMENTS: 'گزارش‌های من',
      LANGUAGE: 'زبان',
      ACCOUNT_SETTINGS: 'تنظیمات حساب کاربری',
      SIGN_OUT: 'خروج',
    },
    AUTH: {
      GENERAL: {
        OR: 'یا',
        SUBMIT_BUTTON: 'ثبت',
        NO_ACCOUNT: 'حساب کاربری ندارید؟',
        SIGNUP_BUTTON: 'ثبت نام',
        FORGOT_BUTTON: 'فراموشی رمز عبور',
        BACK_BUTTON: 'بازگشت',
        PRIVACY: 'حریم خصوصی',
        LEGAL: 'قوانین',
        CONTACT: 'تماس با ما',
      },
      LOGIN: {
        TITLE: 'ورود به حساب کاربری',
        BUTTON: 'ورود',
      },
      FORGOT: {
        TITLE: 'فراموشی رمز عبور',
        DESC: 'ایمیل خود را وارد کنید تا رمز عبور خود را بازنشانی کنید',
        SUCCESS: 'حساب کاربری شما با موفقیت بازنشانی شد.'
      },
      REGISTER: {
        TITLE: 'ثبت نام',
        DESC: 'جزئیات خود را برای ایجاد حساب کاربری وارد کنید',
        SUCCESS: 'حساب کاربری شما با موفقیت ثبت شد.'
      },
      INPUT: {
        EMAIL: 'ایمیل',
        FULLNAME: 'نام کامل',
        PASSWORD: 'رمز عبور',
        CONFIRM_PASSWORD: 'تأیید رمز عبور',
        USERNAME: 'نام کاربری'
      },
      VALIDATION: {
        INVALID: '{{name}} معتبر نیست',
        REQUIRED: '{{name}} اجباری است',
        MIN_LENGTH: 'حداقل طول {{name}} {{min}} است',
        AGREEMENT_REQUIRED: 'پذیرش شرایط و مقررات الزامی است',
        NOT_FOUND: '{{name}} درخواستی یافت نشد',
        INVALID_LOGIN: 'جزئیات ورود نامعتبر است',
        REQUIRED_FIELD: 'فیلد اجباری است',
        MIN_LENGTH_FIELD: 'حداقل طول فیلد:',
        MAX_LENGTH_FIELD: 'حداکثر طول فیلد:',
        INVALID_FIELD: 'فیلد معتبر نیست',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'تعداد رکوردهای انتخاب شده: ',
        ALL: 'همه',
        SUSPENDED: 'تعلیق شده',
        ACTIVE: 'فعال',
        FILTER: 'فیلتر',
        BY_STATUS: 'بر اساس وضعیت',
        BY_TYPE: 'بر اساس نوع',
        BUSINESS: 'کسب و کار',
        INDIVIDUAL: 'شخصی',
        SEARCH: 'جستجو',
        IN_ALL_FIELDS: 'در تمام فیلدها'
      },
      ECOMMERCE: 'تجارت الکترونیک',
      CUSTOMERS: {
        CUSTOMERS: 'مشتریان',
        CUSTOMERS_LIST: 'لیست مشتریان',
        NEW_CUSTOMER: 'مشتری جدید',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'حذف مشتری',
          DESCRIPTION: 'آیا از حذف دائمی این مشتری مطمئن هستید؟',
          WAIT_DESCRIPTION: 'مشتری در حال حذف است...',
          MESSAGE: 'مشتری با موفقیت حذف شده است'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'حذف مشتریان',
          DESCRIPTION: 'آیا از حذف دائمی مشتریان انتخاب شده مطمئن هستید؟',
          WAIT_DESCRIPTION: 'مشتریان در حال حذف هستند...',
          MESSAGE: 'مشتریان انتخاب شده با موفقیت حذف شده‌اند'
        },
        UPDATE_STATUS: {
          TITLE: 'وضعیت مشتریان انتخابی به‌روز شده است',
          MESSAGE: 'وضعیت مشتریان انتخاب شده با موفقیت به‌روز شده‌اند'
        },
        EDIT: {
          UPDATE_MESSAGE: 'مشتری به‌روز شده است',
          ADD_MESSAGE: 'مشتری با موفقیت ایجاد شده است'
        }
      }
    },
    AG_GRID_COLUMNS: {
      ROW_NUMBER: 'شماره ردیف',
      CREATE_DATE: 'تاریخ ایجاد',
      REFER: 'ارجاع',
      DESCRIPTION: 'توضیحات',
      DEBIT: 'بدهی',
      CREDIT: 'اعتبار',
      REMAIN_DEBIT: 'باقیمانده بدهی',
      REMAIN_CREDIT: 'باقیمانده اعتبار',
    },
    AG_GRID_LOCALE: {
      // Set Filter
      SELECT_ALL: '(انتخاب همه)',
      SELECT_ALL_SEARCH_RESULTS: '(انتخاب همه نتایج جستجو)',
      SEARCH_OOO: 'جستجو...',
      BLANKS: '(خالی)',
      NO_MATCHES: 'بدون مطابقت',

      // Number Filter & Text Filter
      FILTER_OOO: 'فیلتر...',
      EQUALS: 'برابر',
      NOT_EQUAL: 'برابر نیست',
      BLANK: 'خالی',
      NOT_BLANK: 'پر',
      EMPTY: 'یکی را انتخاب کنید',

      // Number Filter
      LESS_THAN: 'کمتر از',
      GREATER_THAN: 'بیشتر از',
      LESS_THAN_OR_EQUAL: 'کمتر یا مساوی',
      GREATER_THAN_OR_EQUAL: 'بیشتر یا مساوی',
      IN_RANGE: 'در محدوده',
      IN_RANGE_START: 'از',
      IN_RANGE_END: 'تا',

      // Text Filter
      CONTAINS: 'شامل',
      NOT_CONTAINS: 'شامل نیست',
      STARTS_WITH: 'شروع با',
      ENDS_WITH: 'پایان با',

      // Date Filter
      DATE_FORMAT_OOO: 'yyyy-mm-dd',

      // Filter Conditions
      AND_CONDITION: 'و',
      OR_CONDITION: 'یا',

      // Filter Buttons
      APPLY_FILTER: 'اعمال',
      RESET_FILTER: 'بازنشانی',
      CLEAR_FILTER: 'پاک کردن',
      CANCEL_FILTER: 'لغو',

      // Filter Titles
      TEXT_FILTER: 'فیلتر متنی',
      NUMBER_FILTER: 'فیلتر عددی',
      DATE_FILTER: 'فیلتر تاریخ',
      SET_FILTER: 'تنظیم فیلتر',

      // Group Column Filter
      GROUP_FILTER_SELECT: 'انتخاب فیلد:',

      // Advanced Filter
      ADVANCED_FILTER_CONTAINS: 'شامل',
      ADVANCED_FILTER_NOT_CONTAINS: 'شامل نیست',
      ADVANCED_FILTER_TEXT_EQUALS: 'برابر',
      ADVANCED_FILTER_TEXT_NOT_EQUAL: 'برابر نیست',
      ADVANCED_FILTER_STARTS_WITH: 'شروع با',
      ADVANCED_FILTER_ENDS_WITH: 'پایان با',
      ADVANCED_FILTER_BLANK: 'خالی است',
      ADVANCED_FILTER_NOT_BLANK: 'پر است',
      ADVANCED_FILTER_EQUALS: '=',
      ADVANCED_FILTER_NOT_EQUAL: '!=',
      ADVANCED_FILTER_GREATER_THAN: '>',
      ADVANCED_FILTER_GREATER_THAN_OR_EQUAL: '>=',
      ADVANCED_FILTER_LESS_THAN: '<',
      ADVANCED_FILTER_LESS_THAN_OR_EQUAL: '<=',
      ADVANCED_FILTER_TRUE: 'صحیح است',
      ADVANCED_FILTER_FALSE: 'غلط است',
      ADVANCED_FILTER_AND: 'و',
      ADVANCED_FILTER_OR: 'یا',
      ADVANCED_FILTER_APPLY: 'اعمال',
      ADVANCED_FILTER_VALIDATION_MISSING_COLUMN: 'ستون وجود ندارد',
      ADVANCED_FILTER_VALIDATION_MISSING_OPTION: 'گزینه وجود ندارد',
      ADVANCED_FILTER_VALIDATION_MISSING_VALUE: 'مقدار وجود ندارد',
      ADVANCED_FILTER_VALIDATION_INVALID_COLUMN: 'ستون پیدا نشد',
      ADVANCED_FILTER_VALIDATION_INVALID_OPTION: 'گزینه پیدا نشد',
      ADVANCED_FILTER_VALIDATION_MISSING_QUOTE: 'نقل قول پایانی مقدار وجود ندارد',
      ADVANCED_FILTER_VALIDATION_NOT_A_NUMBER: 'مقدار عددی نیست',
      ADVANCED_FILTER_VALIDATION_MISSING_CONDITION: 'شرط وجود ندارد',
      ADVANCED_FILTER_VALIDATION_JOIN_OPERATOR_MISMATCH: 'عملگرهای پیوست در داخل یک شرط باید یکسان باشند',
      ADVANCED_FILTER_VALIDATION_INVALID_JOIN_OPERATOR: 'عملگر پیوست پیدا نشد',
      ADVANCED_FILTER_VALIDATION_MISSING_END_BRACKET: 'پرانتز پایانی وجود ندارد',
      ADVANCED_FILTER_VALIDATION_EXTRA_END_BRACKET: 'پرانتز پایانی اضافی است',
      ADVANCED_FILTER_VALIDATION_MESSAGE: 'عبارت دارای خطا است. ${VARIABLE1} - ${VARIABLE2}.',
      ADVANCED_FILTER_VALIDATION_MESSAGE_AT_END: 'عبارت دارای خطا است. ${VARIABLE} در پایان عبارت.',

      // Side Bar
      COLUMNS: 'ستون‌ها',
      FILTERS: 'فیلترها',

      // columns tool panel
      PIVOT_MODE: 'حالت پیوت',
      GROUPS: 'گروه‌های ردیف',
      ROW_GROUP_COLUMNS_EMPTY_MESSAGE: 'برای تعیین گروه‌های ردیف، اینجا را بکشید',
      VALUES: 'مقادیر',
      VALUE_COLUMNS_EMPTY_MESSAGE: 'برای تجمیع، اینجا را بکشید',
      PIVOTS: 'برچسب‌های ستون',
      PIVOT_COLUMNS_EMPTY_MESSAGE: 'برای تعیین برچسب‌های ستون، اینجا را بکشید',

      // Header of the Default Group Column
      GROUP: 'گروه',

      // Row Drag
      ROW_DRAG_ROW: 'ردیف',
      ROW_DRAG_ROWS: 'ردیف',

      // Other
      LOADING_OOO: 'در حال بارگذاری...',
      LOADING_ERROR: 'خطا',
      NO_ROWS_TO_SHOW: 'ردیفی برای نمایش وجود ندارد',
      ENABLED: 'فعال',

      // Menu
      PIN_COLUMN: 'سنجاق ستون',
      PIN_LEFT: 'سنجاق به چپ',
      PIN_RIGHT: 'سنجاق به راست',
      NO_PIN: 'بدون سنجاق',
      VALUE_AGGREGATION: 'تجمیع مقدار',
      NO_AGGREGATION: 'بدون تجمیع',
      AUTOSIZE_THIS_COLUMN: 'اندازه‌گیری خودکار این ستون',
      AUTOSIZE_ALL_COLUMNS: 'اندازه‌گیری خودکار همه ستون‌ها',
      GROUP_BY: 'گروه‌بندی بر اساس',
      UNGROUP_BY: 'لغو گروه‌بندی بر اساس',
      UNGROUP_ALL: 'لغو گروه‌بندی همه',
      ADD_TO_VALUES: 'افزودن ${VARIABLE} به مقادیر',
      REMOVE_FROM_VALUES: 'حذف ${VARIABLE} از مقادیر',
      ADD_TO_LABELS: 'افزودن ${VARIABLE} به برچسب‌ها',
      REMOVE_FROM_LABELS: 'حذف ${VARIABLE} از برچسب‌ها',
      RESET_COLUMNS: 'بازنشانی ستون‌ها',
      EXPAND_ALL: 'گسترش همه گروه‌های ردیف',
      COLLAPSE_ALL: 'بستن همه گروه‌های ردیف',
      COPY: 'کپی',
      CTRL_C: 'Ctrl+C',
      CTRL_X: 'Ctrl+X',
      COPY_WITH_HEADERS: 'کپی با سربرگ‌ها',
      COPY_WITH_GROUP_HEADERS: 'کپی با سربرگ‌های گروه',
      CUT: 'برش',
      PASTE: 'چسباندن',
      CTRL_V: 'Ctrl+V',
      EXPORT: 'خروجی‌گیری',
      CSV_EXPORT: 'خروجی‌گیری به فرمت CSV',
      EXCEL_EXPORT: 'خروجی‌گیری به فرمت Excel',

      // Enterprise Menu Aggregation and Status Bar
      SUM: 'جمع',
      FIRST: 'اولین',
      LAST: 'آخرین',
      MIN: 'کمترین',
      MAX: 'بیشترین',
      NONE: 'هیچ',
      COUNT: 'تعداد',
      AVG: 'میانگین',
      FILTERED_ROWS: 'ردیف‌های فیلتر شده',
      SELECTED_ROWS: 'ردیف‌های انتخاب شده',
      TOTAL_ROWS: 'کل ردیف‌ها',
      TOTAL_AND_FILTERED_ROWS: 'ردیف‌ها',
      MORE: 'بیشتر',
      TO: 'تا',
      OF: 'از',
      PAGE: 'صفحه',
      PAGE_LAST_ROW_UNKNOWN: '?',
      NEXT_PAGE: 'صفحه بعدی',
      LAST_PAGE: 'آخرین صفحه',
      FIRST_PAGE: 'اولین صفحه',
      PREVIOUS_PAGE: 'صفحه قبلی',

      // Pivoting
      PIVOT_COLUMN_GROUP_TOTALS: 'مجموع',

      // Enterprise Menu (Charts)
      PIVOT_CHART_AND_PIVOT_MODE: 'نمودار Pivot و حالت Pivot',
      PIVOT_CHART: 'نمودار Pivot',
      CHART_RANGE: 'محدوده نمودار',

      COLUMN_CHART: 'نمودار ستونی',
      GROUPED_COLUMN: 'گروه‌بندی شده',
      STACKED_COLUMN: 'تراکمی',
      NORMALIZED_COLUMN: 'تراکم 100٪',

      BAR_CHART: 'نمودار میله‌ای',
      GROUPED_BAR: 'گروه‌بندی شده',
      STACKED_BAR: 'تراکمی',
      NORMALIZED_BAR: 'تراکم 100٪',

      PIE_CHART: 'نمودار دایره‌ای',
      PIE: 'نمودار دایره‌ای',
      DOUGHNUT: 'نمودار دایره‌ای دونات',

      LINE: 'نمودار خطی',

      XY_CHART: 'نمودار X Y (پراکنده)',
      SCATTER: 'پراکنده',
      BUBBLE: 'حبابی',

      AREA_CHART: 'نمودار سطحی',
      AREA: 'نمودار سطحی',
      STACKED_AREA: 'تراکمی',
      NORMALIZED_AREA: 'تراکم 100٪',

      HISTOGRAM_CHART: 'نمودار توزیع تاریخچه',
      HISTOGRAM_FREQUENCY: 'فراوانی',

      COMBINATION_CHART: 'نمودار ترکیبی',
      COLUMN_LINE_COMBO: 'نمودار ستونی و خطی',
      AREA_COLUMN_COMBO: 'نمودار سطحی و ستونی',

      // Charts
      PIVOT_CHART_TITLE: 'نمودار Pivot',
      RANGE_CHART_TITLE: 'نمودار محدوده',
      SETTINGS: 'تنظیمات',
      DATA: 'داده',
      FORMAT: 'فرمت',
      CATEGORIES: 'دسته‌بندی‌ها',
      DEFAULT_CATEGORY: '(بدون دسته‌بندی)',
      SERIES: 'سری‌ها',
      XY_VALUES: 'مقادیر X Y',
      PAIRED: 'حالت جفتی',
      AXIS: 'محور',
      NAVIGATOR: 'ناوبر',
      COLOR: 'رنگ',
      THICKNESS: 'ضخامت',
      X_TYPE: 'نوع X',
      AUTOMATIC: 'اتوماتیک',
      CATEGORY: 'دسته‌بندی',
      NUMBER: 'عدد',
      TIME: 'زمان',
      AUTO_ROTATE: 'چرخش اتوماتیک',
      X_ROTATION: 'چرخش X',
      Y_ROTATION: 'چرخش Y',
      TICKS: 'نشانه‌ها',
      WIDTH: 'عرض',
      HEIGHT: 'ارتفاع',
      LENGTH: 'طول',
      PADDING: 'فاصله‌گذاری',
      SPACING: 'فضاگذاری',
      CHART: 'نمودار',
      TITLE: 'عنوان',
      TITLE_PLACEHOLDER: 'عنوان نمودار - برای ویرایش دوباره کلیک کنید',
      BACKGROUND: 'زمینه',
      FONT: 'فونت',
      TOP: 'بالا',
      RIGHT: 'راست',
      BOTTOM: 'پایین',
      LEFT: 'چپ',
      LABELS: 'برچسب‌ها',
      SIZE: 'اندازه',
      MIN_SIZE: 'حداقل اندازه',
      MAX_SIZE: 'حداکثر اندازه',
      LEGEND: 'راهنما',
      POSITION: 'موقعیت',
      MARKER_SIZE: 'اندازه نشانگر',
      MARKER_STROKE: 'ضخامت حاشیه نشانگر',
      MARKER_PADDING: 'فاصله‌گذاری حاشیه نشانگر',
      ITEM_SPACING: 'فضاگذاری مورد',
      ITEM_PADDING_X: 'فاصله‌گذاری مورد در X',
      ITEM_PADDING_Y: 'فاصله‌گذاری مورد در Y',
      LAYOUT_HORIZONTAL_SPACING: 'فضاگذاری افقی',
      LAYOUT_VERTICAL_SPACING: 'فضاگذاری عمودی',
      STROKE_WIDTH: 'ضخامت خط',
      LINE_DASH: 'خط چین',
      OFFSET: 'آفست',
      OFFSETS: 'آفست‌ها',
      TOOLTIPS: 'توضیحات',
      CALLOUT: 'پنجره توضیحات',
      MARKERS: 'نشانگرها',
      SHADOW: 'سایه',
      BLUR: 'بی‌وضوحی',
      X_OFFSET: 'آفست X',
      Y_OFFSET: 'آفست Y',
      LINE_WIDTH: 'ضخامت خط',
      NORMAL: 'معمولی',
      BOLD: 'پررنگ',
      ITALIC: 'خمیده',
      BOLD_ITALIC: 'پررنگ و خمیده',
      PREDEFINED: 'پیش‌فرض',
      FILL_OPACITY: 'شفافیت پر کردن',
      STROKE_OPACITY: 'شفافیت خط',
      HISTOGRAM_BIN_COUNT: 'تعداد بن‌های هیستوگرام',
      COLUMN_GROUP: 'ستون',
      BAR_GROUP: 'میله‌ای',
      PIE_GROUP: 'دایره‌ای',
      LINE_GROUP: 'خطی',
      SCATTER_GROUP: 'پراکنده X Y',
      AREA_GROUP: 'سطحی',
      HISTOGRAM_GROUP: 'هیستوگرام',
      COMBINATION_GROUP: 'ترکیبی',
      GROUPED_COLUMN_TOOLTIP: 'گروه‌بندی شده',
      STACKED_COLUMN_TOOLTIP: 'تراکمی',
      NORMALIZED_COLUMN_TOOLTIP: 'تراکم 100٪',
      GROUPED_BAR_TOOLTIP: 'گروه‌بندی شده',
      STACKED_BAR_TOOLTIP: 'تراکمی',
      NORMALIZED_BAR_TOOLTIP: 'تراکم 100٪',
      PIE_TOOLTIP: 'دایره‌ای',
      DOUGHNUT_TOOLTIP: 'دایره‌ای دونات',
      LINE_TOOLTIP: 'خطی',
      GROUPED_AREA_TOOLTIP: 'سطحی',
      STACKED_AREA_TOOLTIP: 'تراکمی',
      NORMALIZED_AREA_TOOLTIP: 'تراکم 100٪',
      SCATTER_TOOLTIP: 'پراکنده',
      BUBBLE_TOOLTIP: 'حبابی',
      HISTOGRAM_TOOLTIP: 'هیستوگرام',
      COLUMN_LINE_COMBO_TOOLTIP: 'نمودار ستونی و خطی',
      AREA_COLUMN_COMBO_TOOLTIP: 'نمودار سطحی و ستونی',
      CUSTOM_COMBO_TOOLTIP: 'ترکیبی دلخواه',
      NO_DATA_TO_CHART: 'هیچ داده‌ای برای تولید نمودار موجود نیست.',
      PIVOT_CHART_REQUIRES_PIVOT_MODE: 'برای نمودار Pivot، حالت Pivot باید فعال شود.',
      CHART_SETTINGS_TOOLBAR_TOOLTIP: 'منو',
      CHART_LINK_TOOLBAR_TOOLTIP: 'متصل به جدول',
      CHART_UNLINK_TOOLBAR_TOOLTIP: 'جدا شده از شبکه',
      CHART_DOWNLOAD_TOOLBAR_TOOLTIP: 'دانلود نمودار',
      SERIES_CHART_TYPE: 'نوع نمودار سری',
      SERIES_TYPE: 'نوع سری',
      SECONDARY_AXIS: 'محور ثانویه',

      // ARIA
      ARIA_ADVANCED_FILTER_INPUT: 'ورودی فیلتر پیشرفته',
      ARIA_CHECKED: 'انتخاب شده',
      ARIA_COLUMN: 'ستون',
      ARIA_COLUMN_GROUP: 'گروه ستون',
      ARIA_COLUMN_LIST: 'لیست ستون',
      ARIA_COLUMN_SELECT_ALL: 'تغییر انتخاب همه ستون‌ها',
      ARIA_DATE_FILTER_INPUT: 'ورودی فیلتر تاریخ',
      ARIA_DEFAULT_LIST_NAME: 'لیست',
      ARIA_FILTER_COLUMNS_INPUT: 'ورودی فیلتر ستون‌ها',
      ARIA_FILTER_FROM_VALUE: 'فیلتر از مقدار',
      ARIA_FILTER_INPUT: 'ورودی فیلتر',
      ARIA_FILTER_LIST: 'لیست فیلتر',
      ARIA_FILTER_TO_VALUE: 'فیلتر تا مقدار',
      ARIA_FILTER_VALUE: 'مقدار فیلتر',
      ARIA_FILTER_MENU_OPEN: 'بازکردن منوی فیلتر',
      ARIA_FILTERING_OPERATOR: 'عملگر فیلتر',
      ARIA_HIDDEN: 'پنهان',
      ARIA_INDETERMINATE: 'نامعلوم',
      ARIA_INPUT_EDITOR: 'ویرایشگر ورودی',
      ARIA_MENU_COLUMN: 'برای باز کردن منوی ستون CTRL + ENTER را فشار دهید.',
      ARIA_ROW_DESELECT: 'برای لغو انتخاب این ردیف فاصله را فشار دهید',
      ARIA_ROW_SELECT_ALL: 'برای تغییر انتخاب همه ردیف‌ها فاصله را فشار دهید',
      ARIA_ROW_TOGGLE_SELECTION: 'برای تغییر انتخاب ردیف فاصله را فشار دهید',
      ARIA_ROW_SELECT: 'برای انتخاب این ردیف فاصله را فشار دهید',
      ARIA_SEARCH: 'جستجو',
      ARIA_SORTABLE_COLUMN: 'برای مرتب‌سازی ENTER را فشار دهید',
      ARIA_TOGGLE_VISIBILITY: 'برای تغییر پدیداری فاصله را فشار دهید',
      ARIA_TOGGLE_CELL_VALUE: 'برای تغییر مقدار سلول فاصله را فشار دهید',
      ARIA_UNCHECKED: 'عدم انتخاب',
      ARIA_VISIBLE: 'پدیدار',
      ARIA_SEARCH_FILTER_VALUES: 'جستجو در مقادیر فیلتر',

      // ARIA Labels for Drop Zones
      ARIA_ROW_GROUP_DROP_ZONE_PANEL_LABEL: 'گروه‌های ردیف',
      ARIA_VALUES_DROP_ZONE_PANEL_LABEL: 'مقادیر',
      ARIA_PIVOT_DROP_ZONE_PANEL_LABEL: 'برچسب‌های ستون',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_DESCRIPTION: 'برای حذف DELETE را فشار دهید',
      ARIA_DROP_ZONE_COLUMN_VALUE_ITEM_DESCRIPTION: 'برای تغییر نوع تجمیع ENTER را فشار دهید',
      ARIA_DROP_ZONE_COLUMN_GROUP_ITEM_DESCRIPTION: 'برای مرتب‌سازی ENTER را فشار دهید',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_AGG_FUNC_SEPARATOR: ' از ',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_SORT_ASCENDING: 'صعودی',
      ARIA_DROP_ZONE_COLUMN_COMPONENT_SORT_DESCENDING: 'نزولی',

      // ARIA Labels for Dialogs
      ARIA_LABEL_COLUMN_MENU: 'منوی ستون',
      ARIA_LABEL_CELL_EDITOR: 'ویرایشگر سلول',
      ARIA_LABEL_DIALOG: 'پنجره گفتگو',
      ARIA_LABEL_SELECT_FIELD: 'انتخاب فیلد',
      ARIA_LABEL_RICH_SELECT_FIELD: 'انتخاب فیلد غنی',
      ARIA_LABEL_TOOLTIP: 'راهنما',
      ARIA_LABEL_CONTEXT_MENU: 'منوی متنی',
      ARIA_LABEL_SUB_MENU: 'زیرمنو',
      ARIA_LABEL_AGGREGATION_FUNCTION: 'تابع تجمیع',
      ARIA_LABEL_ADVANCED_FILTER_AUTOCOMPLETE: 'تکمیل خودکار فیلتر پیشرفته',

      // Number Format (Status Bar, Pagination Panel)
      THOUSAND_SEPARATOR: ',',
      DECIMAL_SEPARATOR: '.',

      // Data types
      TRUE: 'صحیح',
      FALSE: 'غلط',
      INVALID_DATE: 'تاریخ نامعتبر',
      INVALID_NUMBER: 'عدد نامعتبر',
      JANUARY: 'ژانویه',
      FEBRUARY: 'فوریه',
      MARCH: 'مارس',
      APRIL: 'آوریل',
      MAY: 'مه',
      JUNE: 'ژوئن',
      JULY: 'جولای',
      AUGUST: 'اوت',
      SEPTEMBER: 'سپتامبر',
      OCTOBER: 'اکتبر',
      NOVEMBER: 'نوامبر',
      DECEMBER: 'دسامبر',
    },
  }
};
